export const SignUp = {
    // 证件真伪检测 / document spoof detection
    SpoofDetection: 'Authenticity Check',
    SpoofPass: 'Passed',
    SpoofRisk: 'At Risk',
    SpoofTypeScreenRemark: 'Re-photographed',
    SpoofTypePhotoCopy: 'Photocopy',
    SpoofTypeTamper: 'PS Tampered',
    SpoofTypeShortcut: 'Screenshot',
    ParentIdDoc: "Parent's ID Document",
    HouseholdRegister: 'Household Register',
    ParentConsentStatement: 'Guardian Consent Statement',
};
